export const PARTNER_MATCHERS = [
    {
        id: 'miro',
        regex: /^https?:\/\/miro\.com\/app\/board\/.+/,
        replacer: url => {
            return url.replace(/^(https?:\/\/miro\.com\/app)\/board\//, '$1/live-embed/')
        },
        title: 'Miro Board'
    },
    {
        id: 'gdriveFolder',
        regex: /^https:\/\/drive\.google\.com\/drive(?:\/.+)?\/folders\/.+?(?:\?.*)?$/,
        replacer: url => {
            return url.replace(/^https:\/\/drive\.google\.com\/drive(?:\/.+)?\/folders\/(.+?)(?:\?.*)?$/, 'https://drive.google.com/embeddedfolderview?id=$1#grid');
        },
        title: 'GDrive Folder'
    },
    {
        id: 'figma',
        regex: /^https:\/\/www\.figma\.com\/file\/.+/,
        replacer: url => {
            return`https://www.figma.com/embed?embed_host=share&url=${decodeURIComponent(url)}`
        },
        title: 'Figma Prototype'
    },
    {
        id: 'canva',
        regex: /^https:\/\/www\.canva\.com\/design\/.+/,
        replacer: url => {
            return url.replace(/^https:\/\/www\.canva\.com\/design\/(.+?)\/.*/, 'https://www.canva.com/design/$1/view?embed');
        },
        title: 'Canva Design'
    },
    {
        id: 'boxFolder',
        regex: /^https:\/\/app\.box\.com\/folder\/.+?\?s=.+/,
        replacer: url => {
            return url.replace(/^https:\/\/app\.box\.com\/folder\/.+?\?s=(.+)/, 'https://app.box.com/embed/s/$1');
        },
        title: 'Box Folder'
    },
    {
        id: 'boxFile',
        regex: /^https:\/\/app\.box\.com\/file\/.+?\?s=.+/,
        replacer: url => {
            return url.replace(/^https:\/\/app\.box\.com\/file\/.+?\?s=(.+)/, 'https://app.box.com/embed/s/$1');
        },
        title: 'Box File'
    },
    {
        id: 'airtable',
        regex: /^https:\/\/airtable\.com\/.+/,
        replacer: url => {
            return url.replace(/^https:\/\/airtable\.com\/(.+)/, 'https://airtable.com/embed/$1?backgroundColor=green&viewControls=on');
        },
        title: 'Airtable'
    },
    {
        id: 'twitch',
        regex: /^https:\/\/www\.twitch\.tv\/.+/,
        replacer: url => {
            return url.replace(/^https:\/\/www\.twitch\.tv\/(.+)/, 'https://player.twitch.tv/?channel=$1&parent=$HOSTNAME$');
        },
        title: 'Twitch Channel'
    },
    {
        id: 'dropbox',
        regex: /^https:\/\/www\.dropbox\.com\/.+?(\?.*?)$/,
        replacer: url => {
            return url.replace(/(^https:\/\/www\.dropbox\.com\/.+?)(\?.*?)$/, '$1?raw=1');
        },
        title: 'Dropbox File'
    }
];
